import React from 'react'
import { formatGasCost } from '../../../utils/walletUtils'

const TransactionReceipt = ({
  amount,
  selectedToken,
  actionText,
  isShielding,
  estimate,
  wallet
}) => {
  return (
    <div className="card mb-3">
      <div className='card-body p-3'>
        <h6 className="fw-bold mb-4">Transaction Summary</h6>

        <div className="d-flex justify-content-between py-2">
          <span className="">Action:</span>
          <span className="fw-semibold">{actionText} Tokens</span>
        </div>

        <div className="d-flex justify-content-between py-2">
          <span className="">Amount:</span>
          <span className="fw-bold text-primary">
            {amount} {selectedToken?.symbol}
          </span>
        </div>

        <div className="d-flex justify-content-between py-2">
          <span className="">Token:</span>
          <span>{selectedToken?.name}</span>
        </div>

        {estimate && (
          <div className="d-flex justify-content-between py-2">
            <span className="">Estimated Gas:</span>
            <span>
              {formatGasCost(estimate.totalCost, selectedToken?.network)}
            </span>
          </div>
        )}

        <div className="d-flex justify-content-between py-2">
          <span className="">From:</span>
          <small className="font-monospace">
            {isShielding
              ? wallet?.publicWalletAddress?.slice(0, 10) + '...'
              : wallet?.railgunAddress?.slice(0, 10) + '...'}
          </small>
        </div>

        {/* <div className="d-flex justify-content-between">
          <span className="">To:</span>
          <small className="font-monospace">
            {isShielding
              ? wallet?.privateWalletAddress?.slice(0, 10) + '...'
              : wallet?.publicWalletAddress?.slice(0, 10) + '...'}
          </small>
        </div> */}
      </div>
    </div>
  )
}

export default TransactionReceipt
